import LeistungsseiteTemplate from "@/components/feature/LeistungsseiteTemplate";
import { allTestimonials } from "@/data/testimonials";
import Seo, { serviceSchema } from "@/components/feature/Seo";

export default function Waermepumpe() {
  return (
    <>
      <Seo
        title="Wärmepumpe elektrisch einbinden | Zweering Elektrotechnik Emmerich am Rhein"
        description="Elektrotechnische Einbindung Ihrer Wärmepumpe in Photovoltaik, Speicher und Smart-Home — vom Elektro-Meisterbetrieb in Emmerich am Rhein und Umgebung."
        canonical="https://zweering.de/waermepumpe"
        breadcrumbs={[{"name": "Startseite", "url": "https://zweering.de/"}, {"name": "Leistungen", "url": "https://zweering.de/waermepumpe"}, {"name": "Wärmepumpe", "url": "https://zweering.de/waermepumpe"}]}
        schema={serviceSchema("Elektrische Einbindung von Wärmepumpen", "Elektrotechnische Einbindung und intelligente Steuerung von Wärmepumpen im Energiesystem in Emmerich am Rhein und Umgebung.", "https://zweering.de/waermepumpe")}
      />
      <LeistungsseiteTemplate
      label="LEISTUNGEN"
      title="WÄRMEPUMPE — ELEKTRISCH EINGEBUNDEN"
      subline="Ihre Wärmepumpe ist ein großer Stromverbraucher. Wir sorgen dafür, dass sie clever mit Ihrem Energiesystem zusammenarbeitet — in Emmerich am Rhein und Umgebung."
      heroImage="https://www.zweering-elektrotechnik.de/wp-content/uploads/2024/11/IMG_0143.jpeg"
      heroImageAlt="Elektrische Einbindung einer Wärmepumpe in Emmerich am Rhein"
      leadText={
        <>
          Eine Wärmepumpe braucht Strom — viel Strom. Die Frage ist: Woher kommt er, und
          wann läuft die Pumpe? Genau hier setzt unsere{" "}
          <span style={{ color: "#4CAF50" }}>elektrotechnische Einbindung</span> an.
        </>
      }
      panels={[
        {
          title: "DER ELEKTRO-TEIL IST UNSERE SACHE",
          body: "Stromanschluss, Absicherung und die fachgerechte elektrische Einbindung Ihrer Wärmepumpe übernehmen wir als Elektro-Meisterbetrieb — sauber und normgerecht.",
          image: "https://www.zweering-elektrotechnik.de/wp-content/uploads/2024/11/IMG_0143.jpeg",
          imageAlt: "Elektrische Einbindung einer Wärmepumpe in Emmerich am Rhein",
        },
        {
          title: (
            <>
              MIT <span style={{ color: "#4CAF50" }}>EIGENEM STROM</span> HEIZEN
            </>
          ),
          body: "Verbunden mit Ihrer PV-Anlage und Ihrem Speicher kann Ihre Wärmepumpe vorrangig Ihren eigenen Sonnenstrom nutzen — statt teuren Netzstrom.",
          image: "https://www.zweering-elektrotechnik.de/wp-content/uploads/2026/01/IMG_0132.jpg",
          imageAlt: "Wärmepumpe mit Photovoltaik-Anbindung",
        },
        {
          title: "INTELLIGENT GESTEUERT MIT G2",
          body: "Als steuerbarer Verbraucher wird Ihre Wärmepumpe mit G2 Contracting Teil eines aktiven Energiemanagements: Sie läuft dann, wenn Strom günstig oder selbst erzeugt ist.",
          image: "https://www.zweering-elektrotechnik.de/wp-content/uploads/2024/11/IMG_0143.jpeg",
          imageAlt: "Intelligente Wärmepumpen-Steuerung",
        },
      ]}
      testimonials={allTestimonials}
      manifest={"WÄRME AUS STROM.\nSTROM VOM EIGENEN DACH.\nINTELLIGENT GESTEUERT."}
      caseStudy={{
        title: "WÄRMEPUMPE INS ENERGIESYSTEM EINGEBUNDEN",
        text: "Elektrische Einbindung und Steuerung einer Wärmepumpe in Verbindung mit PV und Speicher, in Emmerich am Rhein und Umgebung.",
        href: "/referenzen",
        image: "https://www.zweering-elektrotechnik.de/wp-content/uploads/2024/11/IMG_0143.jpeg",
        imageAlt: "Referenz: Wärmepumpe elektrisch eingebunden in Emmerich am Rhein",
      }}
      faq={[
        {
          frage: "Baut Zweering auch die Wärmepumpe selbst ein?",
          antwort:
            "Den Heizungseinbau übernimmt ein SHK-Fachbetrieb. Wir kümmern uns um den elektrotechnischen Teil: Anschluss, Absicherung, Einbindung ins Energiesystem und intelligente Steuerung — aus einer Hand mit Ihrer übrigen Elektrotechnik.",
        },
        {
          frage: "Warum lohnt sich die Einbindung in mein Energiesystem?",
          antwort:
            "Eine Wärmepumpe ist ein großer Verbraucher. Wenn sie Ihren eigenen Solarstrom nutzt und zu günstigen Zeiten läuft, sparen Sie spürbar.",
        },
        {
          frage: "Was hat G2 Contracting damit zu tun?",
          antwort:
            "G2 Contracting ist die intelligente Steuerungsebene: Sie sorgt dafür, dass Ihre Wärmepumpe dann läuft, wenn es energetisch und wirtschaftlich am sinnvollsten ist.",
        },
      ]}
      ctaText={{
        headline: "WÄRMEPUMPE CLEVER EINBINDEN?",
        subtext:
          "Kostenlose Beratung zur elektrotechnischen Einbindung Ihrer Wärmepumpe.",
        buttonLabel: "Erstberatung anfragen",
        buttonHref: "/kontakt",
        variant: "green",
      }}
      crossLink={{
        title: "G2 CONTRACTING",
        text: "Machen Sie Ihre Wärmepumpe zum Teil eines intelligenten Energiesystems.",
        href: "/g2-contracting",
        image: "https://www.zweering-elektrotechnik.de/wp-content/uploads/2026/01/IMG_0132.jpg",
        imageAlt: "G2 Contracting — intelligentes Energiesystem",
      }}
    />
    </>
  );
}
